import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "ant-row" }
const _hoisted_2 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_5 = { class: "ant-row" }
const _hoisted_6 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_7 = { class: "ant-row" }
const _hoisted_8 = { class: "ant-col ant-col-xs-24 ant-col-xl-20" }
const _hoisted_9 = {
  class: "ant-col ant-col-xs-24 ant-col-xl-4",
  style: {"display":"flex","align-items":"center"}
}
const _hoisted_10 = {
  key: 0,
  class: "acoes-item"
}
const _hoisted_11 = ["onClick"]
const _hoisted_12 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_switch = _resolveComponent("a-switch")!
  const _component_icone = _resolveComponent("icone")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_selecionar_tipo_producao = _resolveComponent("selecionar-tipo-producao")!
  const _component_selecionar_sazonalidade = _resolveComponent("selecionar-sazonalidade")!
  const _component_selecionar_categoria_plano_conta = _resolveComponent("selecionar-categoria-plano-conta")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_card = _resolveComponent("card")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_requisicao_modal = _resolveComponent("requisicao-modal")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_modal, {
      keyboard: false,
      centered: "",
      width: "65%",
      visible: _ctx.modalBase.computedVisivel,
      "onUpdate:visible": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.modalBase.computedVisivel) = $event)),
      "wrap-class-name": "ss-modal-cadastros"
    }, {
      title: _withCtx(() => [
        _createTextVNode(" Cadastro Estrutura CIP "),
        _createVNode(_component_a_switch, {
          checked: _ctx.state.cipEstrutura.ativo,
          "onUpdate:checked": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.cipEstrutura.ativo) = $event)),
          style: {"float":"right"},
          "checked-children": "Ativa",
          "un-checked-children": "Inativa",
          disabled: !_ctx.state.editavel
        }, null, 8, ["checked", "disabled"])
      ]),
      closeIcon: _withCtx(() => [
        _createVNode(_component_icone, { nome: "voltar" })
      ]),
      footer: _withCtx(() => [
        _createElementVNode("button", {
          type: "button",
          class: "ant-btn ant-btn-lg ant-btn-secondary",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.salvar(true)))
        }, [
          _createElementVNode("span", null, _toDisplayString(_ctx.modalBase.textoBotaoSalvarNovo), 1)
        ]),
        _createElementVNode("button", {
          type: "button",
          class: "ant-btn ant-btn-lg ant-btn-primary ss-btn-acao-destaque",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.salvar(false)))
        }, [
          _createElementVNode("span", null, _toDisplayString(_ctx.modalBase.textoBotaoSalvar), 1)
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_skeleton, {
          loading: _ctx.telaBase.carregando
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form, { layout: "vertical" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                  _createElementVNode("div", _hoisted_2, [
                    _createVNode(_component_a_form_item, {
                      label: "Descricao",
                      class: "ss-margin-campos",
                      rules: [{ required: true }]
                    }, {
                      default: _withCtx(() => [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          maxlength: "100",
                          class: "ant-input",
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.cipEstrutura.descricao) = $event)),
                          disabled: !_ctx.state.editavel
                        }, null, 8, _hoisted_3), [
                          [_vModelText, _ctx.state.cipEstrutura.descricao]
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(_component_a_form_item, {
                      label: "Tipo de Producao",
                      class: "ss-margin-campos",
                      rules: [{ required: true }]
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_selecionar_tipo_producao, {
                          varios: false,
                          "codigo-selecionado": _ctx.state.cipEstrutura.codigoTipoProducao,
                          "onUpdate:codigoSelecionado": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.cipEstrutura.codigoTipoProducao) = $event)),
                          empresas: _ctx.telaBase.empresasSelecionadas,
                          disabled: !_ctx.state.editavel
                        }, null, 8, ["codigo-selecionado", "empresas", "disabled"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_component_a_form_item, {
                      label: "Tipo de Periodo",
                      class: "ss-margin-campos",
                      rules: [{ required: true }]
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_selecionar_sazonalidade, {
                          valor: _ctx.state.cipEstrutura.tipoPeriodo,
                          "onUpdate:valor": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.cipEstrutura.tipoPeriodo) = $event)),
                          disabled: !_ctx.state.editavel
                        }, null, 8, ["valor", "disabled"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(_component_a_form_item, {
                      label: "Categoria",
                      class: "ss-margin-campos"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_selecionar_categoria_plano_conta, {
                          codigoSelecionado: _ctx.state.codigoPlanoContaCategoria,
                          "onUpdate:codigoSelecionado": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.codigoPlanoContaCategoria) = $event)),
                          descricaoSelecionado: _ctx.state.nomeCategoriaFinanceira,
                          "onUpdate:descricaoSelecionado": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.nomeCategoriaFinanceira) = $event)),
                          empresas: _ctx.telaBase.empresasSelecionadas,
                          disabled: !_ctx.state.editavel
                        }, null, 8, ["codigoSelecionado", "descricaoSelecionado", "empresas", "disabled"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_a_form_item, {
                      label: " ",
                      class: "ss-margin-campos",
                      style: {"margin-bottom":"0","width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("button", {
                          class: "ant-btn ant-btn-secondary",
                          style: {"width":"100%"},
                          onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.adicionarCategoria && _ctx.adicionarCategoria(...args)))
                        }, _toDisplayString(_ctx.state.categoriaSelecionada === -1 ? 'Adicionar' : 'Editar'), 1)
                      ]),
                      _: 1
                    })
                  ])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_card, {
              titulo: "CATEGORIAS",
              class: "ss-padding-separacao-esquerda"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_table, {
                  columns: _ctx.gradeBase.colunas.filter(item => item.visible),
                  "data-source": _ctx.state.cipEstrutura.categorias,
                  rowKey: "codigoPlanoContaCategoria",
                  pagination: false,
                  size: "small",
                  loading: _ctx.gradeBase.buscandoDados
                }, {
                  bodyCell: _withCtx(({ column, index }) => [
                    (column.customRenderRow === _ctx.ECustomRenderRow.IconeAcoes)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                          _createElementVNode("a", {
                            onClick: ($event: any) => (_ctx.editarCategoria(index))
                          }, [
                            _createVNode(_component_icone, { nome: "editar" })
                          ], 8, _hoisted_11),
                          _createElementVNode("a", {
                            onClick: ($event: any) => (_ctx.excluirCategoria(index))
                          }, [
                            _createVNode(_component_icone, { nome: "excluir" })
                          ], 8, _hoisted_12)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["columns", "data-source", "loading"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["loading"]),
        _createVNode(_component_requisicao_modal, {
          visivel: _ctx.modalBase.exibirRequisicaoModal,
          "onUpdate:visivel": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.modalBase.exibirRequisicaoModal) = $event)),
          apresentarBarraProgresso: _ctx.modalBase.apresentarBarraProgresso,
          fraseBarraProgresso: _ctx.modalBase.fraseBarraProgresso,
          retornoRequisicao: _ctx.modalBase.retornoRequisicao
        }, null, 8, ["visivel", "apresentarBarraProgresso", "fraseBarraProgresso", "retornoRequisicao"])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}